import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTodoTaskAction } from '../actions/updateTodoTask.action';
import { FlowTask } from '../interfaces/flowTask.interface';

export const useUpdateTodoTask = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ taskId, updates }: { taskId: string; updates: Partial<FlowTask> }) =>
      updateTodoTaskAction(taskId, updates),
    onSuccess: (updatedTask) => {
      // Update cache optimistically instead of invalidating to prevent lag
      queryClient.setQueryData(['todo-tasks'], (oldData: FlowTask[] | undefined) => {
        if (!oldData) return oldData;
        return oldData.map((task) => (task.uid === updatedTask.uid ? updatedTask : task));
      });
    },
    onSettled: () => {
      // Always invalidate to ensure consistency across components
      queryClient.invalidateQueries({ queryKey: ['todo-tasks'] });
    },
  });
};

